import { render, staticRenderFns } from "./vizecesidi.vue?vue&type=template&id=ac57da62&"
import script from "./vizecesidi.vue?vue&type=script&lang=js&"
export * from "./vizecesidi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports